export enum NotificationStatusEnum {
  READ = 'Lu',
  UN_READ = 'Non lu',
  ARCHIVED = 'Archivé',
}
